import { api } from "../api";

/**
 * checklistFindAllLastExportResponse - Function that finds on database all last checklist and export in a PDF/XSLX file  
 * method GET  
 * @async-function
 */
const checklistFindAllLastExportResponse = async (token: string, customerId: number, departmentId: number, exportType: string, ignoreDepartments: boolean = false, simpleXlsxExport = false) => {
    const response = await api.get(
        `/checklists/last/all/${customerId}/${departmentId}/${exportType}/export?ignoreDepartments=${ignoreDepartments}&simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default checklistFindAllLastExportResponse;